(() => {
  'use strict';

  if (window.__tpPhotoCartSummaryLoaded) return;
  window.__tpPhotoCartSummaryLoaded = true;

  const PHOTO_BATCH_KEY = '_lotto_foto';
  const PHOTO_TOTAL_KEY = '_totale_formato';
  const PHOTO_FORMAT_KEY = '_formato';
  const PHOTO_MATERIAL_KEY = '_materiale';
  const CART_PATH = '/cart';
  const STYLE_ID = 'tp-photo-cart-summary-style';
  const SUMMARY_CLASS = 'tp-photo-cart-summary';
  const ROOT_ROUTE = window.Shopify?.routes?.root || '/';

  if (window.location.pathname.replace(/\/$/, '') !== CART_PATH) return;

  const formatMoney = (cents, currency = 'EUR') => new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency,
  }).format((Number(cents) || 0) / 100);

  const escapeHtml = (value) => String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const addStyles = () => {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .${SUMMARY_CLASS} {
        margin-top: 1rem;
        padding: 1rem 1.1rem;
        border: 1px solid rgba(var(--color-foreground), .14);
        border-radius: 10px;
        background: rgba(var(--color-foreground), .035);
      }
      .${SUMMARY_CLASS}__title {
        margin: 0 0 .55rem;
        font-weight: 700;
      }
      .${SUMMARY_CLASS}__line {
        margin: .2rem 0;
      }
      .${SUMMARY_CLASS}__quantity {
        margin: .65rem 0 .2rem;
        font-size: 1.08em;
        font-weight: 700;
      }
      .${SUMMARY_CLASS}__remove {
        margin-top: .8rem;
        padding: 0;
        border: 0;
        color: rgb(var(--color-link));
        background: transparent;
        text-decoration: underline;
        cursor: pointer;
        font: inherit;
      }
      .${SUMMARY_CLASS}__remove[disabled] {
        opacity: .55;
        cursor: wait;
      }
      .tp-photo-cart-group-main .cart-item__quantity-wrapper,
      .tp-photo-cart-group-main quantity-popover,
      .tp-photo-cart-group-main cart-remove-button,
      .tp-photo-cart-group-main .product-option {
        display: none !important;
      }
      .tp-photo-cart-group-hidden {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  };

  const replacePhotoShippingCopy = () => {
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    const nodes = [];

    while (walker.nextNode()) {
      const value = walker.currentNode.nodeValue || '';
      if (/Spedizione Standard €6|Spedizione standard €6/.test(value)) nodes.push(walker.currentNode);
    }

    nodes.forEach((node) => {
      node.nodeValue = node.nodeValue
        .replace(/Spedizione Standard €6/g, 'Spedizione Standard Stampe Foto €4,50')
        .replace(/Spedizione standard €6/g, 'Spedizione standard Stampe Foto €4,50');
    });
  };

  const setGroupTotal = (row, totalCents, currency) => {
    const formatted = formatMoney(totalCents, currency);
    const prices = row.querySelectorAll('.cart-item__totals .price');
    prices.forEach((price) => {
      price.textContent = formatted;
    });
  };

  const removePhotoBatch = async (keys, button) => {
    button.disabled = true;
    const oldText = button.textContent;
    button.textContent = 'Rimozione…';

    try {
      const updates = Object.fromEntries(keys.map((key) => [key, 0]));
      const response = await fetch(`${ROOT_ROUTE}cart/update.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      window.location.reload();
    } catch (error) {
      console.error('[TP Photo cart] Rimozione lotto non riuscita', error);
      button.disabled = false;
      button.textContent = oldText;
      window.alert('Non è stato possibile rimuovere tutte le foto. Riprova.');
    }
  };

  const buildSummary = (group, currency) => {
    const firstItem = group.entries[0].item;
    const properties = firstItem.properties || {};
    const declaredTotal = Number(properties[PHOTO_TOTAL_KEY]);
    const summedTotal = group.entries.reduce((total, entry) => total + Math.max(0, Number(entry.item.quantity) || 0), 0);
    const totalQuantity = declaredTotal > 0 ? declaredTotal : summedTotal;
    const totalPrice = group.entries.reduce((total, entry) => total + Math.max(0, Number(entry.item.final_line_price) || 0), 0);
    const format = properties[PHOTO_FORMAT_KEY] || firstItem.variant_options?.[0] || '';
    const material = properties[PHOTO_MATERIAL_KEY] || firstItem.variant_options?.[1] || '';

    const summary = document.createElement('div');
    summary.className = SUMMARY_CLASS;
    summary.innerHTML = `
      <p class="${SUMMARY_CLASS}__title">Riepilogo stampe fotografiche</p>
      ${format ? `<p class="${SUMMARY_CLASS}__line">Formato: ${escapeHtml(format)}</p>` : ''}
      ${material ? `<p class="${SUMMARY_CLASS}__line">Carta: ${escapeHtml(material.replace(/^Carta\s+/i, ''))}</p>` : ''}
      <p class="${SUMMARY_CLASS}__quantity">Quantità totale: ${totalQuantity} ${totalQuantity === 1 ? 'foto' : 'foto'}</p>
      <p class="${SUMMARY_CLASS}__line">Totale: ${escapeHtml(formatMoney(totalPrice, currency))}</p>
    `;

    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = `${SUMMARY_CLASS}__remove`;
    remove.textContent = 'Rimuovi tutte le foto';
    remove.addEventListener('click', () => removePhotoBatch(group.entries.map((entry) => entry.item.key), remove));
    summary.appendChild(remove);

    return { summary, totalPrice };
  };

  const applyPhotoCartSummary = async () => {
    const currentRows = document.querySelectorAll('[id^="CartItem-"]');
    if (!currentRows.length || document.querySelector(`.${SUMMARY_CLASS}`)) return;

    const response = await fetch(`${ROOT_ROUTE}cart.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });
    if (!response.ok) throw new Error(`Carrello non disponibile (${response.status})`);

    const cart = await response.json();
    const groups = new Map();

    cart.items.forEach((item, index) => {
      const batchId = item.properties?.[PHOTO_BATCH_KEY];
      if (!batchId) return;

      const row = document.getElementById(`CartItem-${index + 1}`);
      if (!row) return;

      if (!groups.has(batchId)) groups.set(batchId, { batchId, entries: [] });
      groups.get(batchId).entries.push({ item, row });
    });

    if (!groups.size) return;
    addStyles();

    groups.forEach((group) => {
      const firstEntry = group.entries[0];
      firstEntry.row.classList.add('tp-photo-cart-group-main');
      firstEntry.row.dataset.tpPhotoBatch = group.batchId;

      group.entries.slice(1).forEach((entry) => {
        entry.row.classList.add('tp-photo-cart-group-hidden');
        entry.row.hidden = true;
        entry.row.setAttribute('aria-hidden', 'true');
        entry.row.dataset.tpPhotoBatch = group.batchId;
      });

      const details = firstEntry.row.querySelector('.cart-item__details') || firstEntry.row.querySelector('td') || firstEntry.row;
      const { summary, totalPrice } = buildSummary(group, cart.currency || 'EUR');
      details.appendChild(summary);
      setGroupTotal(firstEntry.row, totalPrice, cart.currency || 'EUR');
    });

    const photoOnly = cart.items.length > 0 && cart.items.every((item) => Boolean(item.properties?.[PHOTO_BATCH_KEY]));
    if (photoOnly) replacePhotoShippingCopy();
  };

  const run = () => applyPhotoCartSummary().catch((error) => {
    console.error('[TP Photo cart] Riepilogo non applicato', error);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  const cartRoot = document.querySelector('main-cart-items');
  if (cartRoot) {
    const observer = new MutationObserver(() => {
      if (cartRoot.querySelector('[id^="CartItem-"]') && !cartRoot.querySelector(`.${SUMMARY_CLASS}`)) run();
    });
    observer.observe(cartRoot, { childList: true, subtree: true });
  }
})();
